import { ExtensionRequest } from '../../store/types';
import {
    ExtensionRequestFileOfProofType,
    ExtensionRequestState,
} from '../../utils/utils';
import {
    ExtensionRequestAcademicAcceptedIcon,
    ExtensionRequestAcademicDeclinedIcon,
    ExtensionRequestAcademicPendingIcon,
    ExtensionRequestMedicalAcceptedIcon,
    ExtensionRequestMedicalDeclinedIcon,
    ExtensionRequestMedicalPendingIcon,
} from './icons/icons';

interface ExtensionRequestBadgeProps {
    extensionRequest: ExtensionRequest;
}

const getExtensionRequestIcon = (extensionRequest: ExtensionRequest) => {
    switch (extensionRequest.fileOfProofType) {
        case ExtensionRequestFileOfProofType.SickNote:
            return getERMedicalIcon(extensionRequest);
        case ExtensionRequestFileOfProofType.AcademicReason:
            return getERAcademicIcon(extensionRequest);
        default:
            return null;
    }
};

const getERMedicalIcon = (extensionRequest: ExtensionRequest) => {
    switch (extensionRequest.state) {
        case ExtensionRequestState.Sent:
        case ExtensionRequestState.Received:
            return <ExtensionRequestMedicalPendingIcon />;
        case ExtensionRequestState.Accepted:
            return <ExtensionRequestMedicalAcceptedIcon />;
        case ExtensionRequestState.Declined:
            return <ExtensionRequestMedicalDeclinedIcon />;
        default:
            return null;
    }
};
const getERAcademicIcon = (extensionRequest: ExtensionRequest) => {
    switch (extensionRequest.state) {
        case ExtensionRequestState.Sent:
        case ExtensionRequestState.Received:
            return <ExtensionRequestAcademicPendingIcon />;
        case ExtensionRequestState.Accepted:
            return <ExtensionRequestAcademicAcceptedIcon />;
        case ExtensionRequestState.Declined:
            return <ExtensionRequestAcademicDeclinedIcon />;
        default:
            return null;
    }
};

const ExtensionRequestBadge = ({
    extensionRequest,
}: ExtensionRequestBadgeProps) => {
    return getExtensionRequestIcon(extensionRequest);
};

export default ExtensionRequestBadge;
